// extracted by mini-css-extract-plugin
var _1 = "logoutButton__fcT9P";
export { _1 as "logoutButton" }
export default { "logoutButton": _1 }
